// extracted by mini-css-extract-plugin
module.exports = {"fill-politico-red":"_3J_0Tvd2GjvHUM_0CrG22u","styles":"_1ByAqFNLipqgPXDb8zBK_w"};